import React from 'react';

const Heart = ({
  height = 16,
  borderColor = '#494949',
  backgroundColor = 'white',
  selected = false,
}) => {
  const width = height;

  if (selected) {
    return (
      <svg height={height} width={width} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 6.48525V6.23603C0 3.23252 2.17078 0.67072 5.13047 0.177439C7.05117 -0.148694 9.08359 0.489822 10.4844 1.89275L11 2.40752L11.477 1.89275C12.9164 0.489822 14.9102 -0.148694 16.8695 0.177439C19.8301 0.67072 22 3.23252 22 6.23603V6.48525C22 8.26845 21.2609 9.97431 19.9547 11.1903L12.1902 18.4392C11.868 18.7399 11.4426 18.9075 11 18.9075C10.5574 18.9075 10.132 18.7399 9.80977 18.4392L2.04488 11.1903C0.740352 9.97431 1.28906e-05 8.26845 1.28906e-05 6.48525H0Z" fill={backgroundColor} />
      </svg>
    );
  }

  return (
    <svg height={height} width={width} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.9613 2.40752L11.477 1.89275C12.9164 0.489822 14.9102 -0.148694 16.8695 0.177439C19.8301 0.67072 22 3.23252 22 6.23603V6.48525C22 8.26845 21.2609 9.97431 19.9547 11.1903L12.1902 18.4392C11.868 18.7399 11.4426 18.9075 11 18.9075C10.5574 18.9075 10.132 18.7399 9.80977 18.4392L2.04488 11.1903C0.740352 9.97431 0 8.26845 0 6.48525V6.23603C0 3.23252 2.17078 0.67072 5.13047 0.177439C7.05117 -0.148694 9.08359 0.489822 10.4844 1.89275L10.9613 2.40752ZM10.9613 4.354L9.51328 2.86299C8.42617 1.77631 6.875 1.28045 5.3582 1.53353C3.0598 1.91681 1.33633 3.90713 1.33633 6.23603V6.48525C1.33633 7.89033 1.95723 9.22666 2.98289 10.1849L10.7465 17.4337C10.8152 17.4981 10.9055 17.5325 10.9613 17.5325C11.0945 17.5325 11.1848 17.4981 11.2535 17.4337L19.018 10.1849C20.0406 9.22666 20.625 7.89033 20.625 6.48525V6.23603C20.625 3.90713 18.9406 1.91681 16.6418 1.53353C15.0863 1.28045 13.5738 1.77631 12.4867 2.86299L10.9613 4.354Z" fill={borderColor} />
    </svg>
  );
};

export default Heart;
